<div class="flex flex-col h-full w-full overflow-hidden">
  <div class="flex flex-col gap-2 flex-1 min-h-0 overflow-hidden">
    @if (showHeading) {
      <span class="text-gray-900 text-sm font-medium">Letzte Prüfungen</span>
    }

    @if (hasChecks) {
      <!-- Eine Karte pro Lauf über die volle Breite. Nur vertikal scrollen. -->
      <div class="flex flex-col gap-2 flex-1 overflow-y-auto overflow-x-hidden">
        @for (check of latestChecks; track check.id) {
          <div (click)="onCheckClick(check)"
               class="p-3 border border-gray-200 rounded-lg bg-white cursor-pointer hover:bg-gray-50 transition-colors">
            @if (wide) {
              <!-- Karteninhalt im Spaltenraster: fr-Spalten in ähnlicher Größe, damit die Abstände
                   gleichmäßig sind und alles über die Karten hinweg untereinander steht.
                   min-h-[30px] plus p-3 der Karte ergibt 54px – dieselbe Höhe wie eine
                   Kennzahlen-Box in "Übersicht Prüfungen". -->
              <div class="grid grid-cols-[16px_minmax(0,3fr)_minmax(0,2fr)_minmax(0,2fr)_112px_128px] items-center gap-4 min-h-[30px]">
                <fa-icon [class]="getStatusIconClass(check)" [icon]="getStatusIcon(check)"
                         class="text-svg-16"></fa-icon>
                <span [title]="getCheckName(check)"
                      class="text-sm font-medium text-gray-900 truncate">{{ getCheckName(check) }}</span>
                <span [title]="getCheckTypeLabel(check)"
                      class="text-sm font-normal text-gray-500 truncate">{{ getCheckTypeLabel(check) }}</span>
                <span [title]="check.checkerName ?? ''"
                      class="flex flex-row items-center gap-1.5 min-w-0 text-sm font-normal text-gray-900">
                  <fa-icon [icon]="faUser" class="text-xs text-gray-500 shrink-0"></fa-icon>
                  <span class="truncate">{{ check.checkerName }}</span>
                </span>
                <span class="flex flex-row items-center gap-1.5 text-sm font-normal text-gray-900">
                  <fa-icon [icon]="faClock" class="text-xs text-gray-500 shrink-0"></fa-icon>
                  {{ check.checkDate | date:'dd.MM.yyyy' }}
                </span>
                <bic-badge [type]="getStatusBadgeType(check)"
                           class="justify-self-end">{{ getStatusLabel(check) }}</bic-badge>
              </div>
            } @else {
              <!-- Schmal: Name und Status oben, die übrigen Angaben in einer zweiten Zeile. -->
              <div class="flex flex-col gap-2">
                <div class="flex flex-row items-center gap-2">
                  <fa-icon [class]="getStatusIconClass(check)" [icon]="getStatusIcon(check)"
                           class="text-svg-16 shrink-0"></fa-icon>
                  <span [title]="getCheckName(check)"
                        class="text-sm font-medium text-gray-900 truncate flex-1 min-w-0">{{ getCheckName(check) }}</span>
                  <bic-badge [type]="getStatusBadgeType(check)">{{ getStatusLabel(check) }}</bic-badge>
                </div>
                <div class="flex flex-row items-center gap-4 text-sm font-normal text-gray-900">
                  <span [title]="getCheckTypeLabel(check)"
                        class="text-gray-500 truncate flex-1 min-w-0">{{ getCheckTypeLabel(check) }}</span>
                  <span class="flex flex-row items-center gap-1.5 shrink-0">
                    <fa-icon [icon]="faClock" class="text-xs text-gray-500"></fa-icon>
                    {{ check.checkDate | date:'dd.MM.yyyy' }}
                  </span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <div [appSkeletonLoading]="loading" class="flex flex-col gap-2 flex-1 overflow-clip rounded-lg">
        <app-empty-state [icon]="faClipboardList" message="Es wurden noch keine Prüfungen ausgeführt">
          <bic-button (onClick)="createCheck.emit()" buttonType="white">
            Prüfung starten
            <fa-icon [icon]="faChevronRight" iconRight></fa-icon>
          </bic-button>
        </app-empty-state>
      </div>
    }
  </div>

</div>
